import Record from "./base"

export default class Path extends Record {
  constructor(...args) {
    super(...args)
    const [model, props] = args
  }
}
